import React from "react";
import { useStore } from "react-redux";

import { ModalLayout } from "./ModalLayout";

export const KontoDeckungPopup = (props) => {
  const { rightStorage } = useStore().getState();  
  const disableOrderButton = !rightStorage.isEmpty() && rightStorage.isVerseNeoServicecenter();
  const modalText = disableOrderButton
    ? "Das ausgewählte Konto weist keine ausreichende Deckung aus. "
    : "Das ausgewählte Konto weist keine ausreichende Deckung aus. Wollen Sie die Bestellung trotzdem ausführen? Sorgen Sie in diesem Fall im Anschluss für ausreichende Deckung.";

  return (
    <ModalLayout>
      <div className="modal-body fs-5">
        <div id="modaltext">
          {modalText}
        </div>
        <br />
        <div className="modal-footer justify-content-between">
          <button
            type="button"
            data-bs-dismiss="modal"
            className="btn btn-danger"
          >
            Abbrechen
          </button>
          {!disableOrderButton && (
            <button
              onClick={() => props.akzeptiereNichtGedecktesKonto()}
              className="btn btn-success float-end"
              disabled={disableOrderButton}
            >
              Kostenpflichtig bestellen
            </button>
          )}
        </div>
      </div>
    </ModalLayout>
  );
}
